import React from 'react';
import { color as palette } from "@/constants/palette";

function HorizontalLine() {
  return (
    <svg aria-hidden="true" focusable="false"
      xmlns='http://www.w3.org/2000/svg'
      width='100%'
      height='1'
      viewBox='0 0 100 1'
      fill='none'
      preserveAspectRatio='none'
    >
      <path
        fillRule='evenodd'
        clipRule='evenodd'
        d='M0 0.5C0 0.223858 0.227043 0 0.507114 0H498.493C498.773 0 499 0.223858 499 0.5C499 0.776142 498.773 1 498.493 1H0.507114C0.227043 1 0 0.776142 0 0.5Z'
        fill={palette.fill}
      />
    </svg>
  );
}

export default HorizontalLine;
